import { ElDialog, ElMessageBox, ElButton, ElForm, ElInput } from "element-plus";

const components = [ElDialog, ElMessageBox, ElButton, ElForm, ElInput];
const options = { size: 'small', zIndex: 3000 };

const install = function ins(app) {
    for (let i = 0; i < components.length; i++) {
        app.component(components[i].name, components[i]);
    }
    app.config.globalProperties.$ELEMENT = options;
}

const API = {
    install,
}

export default Object.assign(API, components);